document.addEventListener('DOMContentLoaded', function() {

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('adev--is-ready');
                observer.unobserve(entry.target);
            }
        });
    });

    const readyElements = document.querySelectorAll('[data-adev-observe="true"]');
    readyElements.forEach((el) => observer.observe(el));

    const messages = document.querySelectorAll('.newsletter-message.auto-hide');

    messages.forEach(function(message) {
        setTimeout(function() {
            message.classList.add('hiding');
            setTimeout(function() {
                if (message.parentNode) {
                    message.style.display = 'none';
                }
            }, 300); // Match animation duration
        }, 3000); // 3 seconds
    });

    // Prevent zoom on input focus for iOS
    const inputs = document.querySelectorAll('.newsletter-input');
    inputs.forEach(function(input) {
        input.addEventListener('touchstart', function() {
            // No action needed, just prevents default zoom behavior
        }, {
            passive: true
        });
    });
});